// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__7VZ1-","iconBadge":"Badge_iconBadge__hAOeu","icon":"Badge_icon__OO75W"};